import axios from 'axios';
let DEVICE_DATA_MODEL_DEV = '25d910c7-6ee0-429b-9dd3-4a883b116246';
let DEVICE_DATA_MODEL_PRD = '25d910c7-6ee0-429b-9dd3-4a883b116246';
let LOOKUP_DATA_MODEL_DEV = '5aefcc83-336f-463c-ae80-e2ed27ccbe11';
let LOOKUP_DATA_MODEL_PRD = '5aefcc83-336f-463c-ae80-e2ed27ccbe11';
let LOOKUP_PROP_SET_DEV = '7f3f01a8-6fb9-4ab2-86bb-ca4f40f55f21';
let LOOKUP_PROP_SET_PRD = '7f3f01a8-6fb9-4ab2-86bb-ca4f40f55f21';
let BASE_URL = "https://api.galencloud.com"

let X_TENENT_DOMAIN_DEV = 'photonicare-dev.galencloud.com';
let X_TENENT_DOMAIN_PRD = 'photonicare.galencloud.com';

class galenApi {

	static error = {};

	constructor() {
		Object.defineProperies(this.error, {
			UNKNOWN_API_ERROR_MSG: {
				value: 'Unknown API Error',
				writable: false
			}, AUTH_ERROR: {
				value: 'Authentication Error',
				writable: false
			}, NOT_FOUND_ERROR: {
				value: 'Component Not found',
				writable: false
			}
		});
	}

	// send call with access credentials and return an auth token
	static async login(isProd, username, password) {

		let url = new URL('https://api.galencloud.com/auth/login');
		url.search = new URLSearchParams({ emailAddress: username, password: password });

		try {
			let response = await axios.post(url, {}, {
				headers: {
					'Content-Type': 'application/json',
					'X-TENANT-DOMAIN': isProd ? X_TENENT_DOMAIN_PRD : X_TENENT_DOMAIN_DEV,
					'X-API-VERSION': '3',
					'X-APP-TYPE': 'Device'
				},
			});
			if (typeof response.headers.authorization === 'string') {
				// return the authentication token for further use of the API
				return { success: true, token: response.headers.authorization };
			}
		} catch (error) {

			// if invalid response, print error and set token to null
			if (error.response.status === 412) {
				return { success: false, token: null, errorType: this.error.AUTH_ERROR, errorMessage: "Incorrect username or password" }
			}
			else {
				return { success: false, token: null, errorType: this.error.AUTH_ERROR, errorMessage: "Unknown authentication error" }
			}
		}
	}

	// get a list of practices that the user has permission to see
	static async getPractices(isProd, token) {

		let response = null;
		try {
			response = await axios.get('https://api.galencloud.com/user/practice?pageNumber=0&pageSize=1000', {
				headers: {
					'x-tenant-domain': isProd ? X_TENENT_DOMAIN_PRD : X_TENENT_DOMAIN_DEV,
					'x-api-version': 3,
					'x-app-type': 'Device',
					'authorization': token,
				}
			});
		} catch (e) {
			if (e.response.status === 401) return { success: false, practiceList: [], errorType: this.error.AUTH_ERROR };
			if (e.response.status === 412) return { success: false, practiceList: [], errorType: this.error.AUTH_ERROR };
			else return { success: false, practiceList: [], errorType: this.error.UNKNOWN_API_ERROR_MSG };
		}
		if (response.status !== 200) return { success: false, practiceList: [], errorType: this.error.UNKNOWN_API_ERROR_MSG };

		let practiceList = response.data.content.map((element) => {
			return { key: element.practiceId, value: element.name, };
		});

		return { success: true, practiceList: practiceList }
	}

	static async getPracticeId(isProd, token, practiceName) {
		let response = null;
		try {
			response = await axios.get('https://api.galencloud.com/user/practice', {
				headers: {
					'x-tenant-domain': isProd ? X_TENENT_DOMAIN_PRD : X_TENENT_DOMAIN_DEV,
					'x-api-version': 3,
					'x-app-type': 'Device',
					'authorization': token,
				},
				params: { name: practiceName }
			});
		} catch (e) {
			if (e.response.status === 401) return { success: false, practiceName: "", practiceId: "", errorType: this.error.AUTH_ERROR };
			if (e.response.status === 412) return { success: false, practiceName: "", practiceId: "", errorType: this.error.AUTH_ERROR };
			else return { success: false, practiceName: "", errorType: this.error.UNKNOWN_API_ERROR_MSG };
		}
		if (response.status !== 200) return { success: false, practiceName: "", practiceId: "", errorType: this.error.UNKNOWN_API_ERROR_MSG };
		let practiceInfo = { id: response.data.content[0].practiceId, name: response.data.content[0].name, success: true };
		return practiceInfo;
	}

	// get a list of serials within a practice
	static async lookupSerials(isProd, token) {
		let response = null;
		try {
			response = await axios.post('https://api.galencloud.com/data/devicedata-advanced?pageNumber=0&pageSize=10000',
				{
					"deviceDataModelId": isProd ? LOOKUP_DATA_MODEL_PRD : LOOKUP_DATA_MODEL_DEV,
					"deviceCriteria": null,
					"devicePropertyCodes": ["Deviceid", "Serial"],
				},
				{
					headers: {
						'x-tenant-domain': isProd ? X_TENENT_DOMAIN_PRD : X_TENENT_DOMAIN_DEV,
						'x-api-version': 3,
						'x-app-type': 'Device',
						'authorization': token,
					}
				});
		} catch (e) {
			return { success: false, snLookupList: [], errorType: this.error.UNKNOWN_API_ERROR_MSG };
		}
		if (response.status !== 200) return { success: false, snLookupList: [], errorType: this.error.UNKNOWN_API_ERROR_MSG };;
		let snList = response.data.content.map((element) => {
			return { serial: element.data.Serial.value, deviceId: element.data.Deviceid.value };
		});
		return { success: true, snLookupList: snList }
	}

	static async getDevices(isProd, token, practice) {
		let response = null;
		if (practice.id === null) practice = await this.getPracticeId(isProd, token, practice.name);
		try {
			response = await axios.post('https://api.galencloud.com/data/devicedata/aggregate?pageNumber=0&pageSize=10000',
				{
					"deviceDataModelId": isProd ? DEVICE_DATA_MODEL_PRD : DEVICE_DATA_MODEL_DEV,
					"dataPropertyCode": "Deviceid",
					"options": {
						"propertyCode": "Deviceid",
						"aggregationType": "Count"
					},
					"ownerFilter": {
						"users": [],
						"practices": practice.id !== null ? [practice.id] : [],
						"suppliers": []
					}
				},
				{
					headers: {
						'x-tenant-domain': isProd ? X_TENENT_DOMAIN_PRD : X_TENENT_DOMAIN_DEV,
						'x-api-version': 3,
						'x-app-type': 'Device',
						'authorization': token,
					}
				});
		} catch (e) {
			if (e.response.status === 404) {
				return { success: true, deviceList: [] }
			} else {
				return { success: false, deviceList: [], errorType: this.error.UNKNOWN_API_ERROR_MSG };
			}
		}
		if (response.status !== 200) return { success: false, deviceList: [], errorType: this.error.UNKNOWN_API_ERROR_MSG };;

		let deviceList = response.data.content.map((element) => {
			return { value: element.view.bucket, key: element.view.bucket };
		})

		return { success: true, deviceList: deviceList }
	}

	static async getExams(isProd, token, practiceId, deviceId) {
		let response = null;
		try {
			response = await axios.post('https://api.galencloud.com/data/devicedata-advanced?pageNumber=0&pageSize=1000',
				{
					"deviceDataModelId": isProd ? DEVICE_DATA_MODEL_PRD : DEVICE_DATA_MODEL_DEV,
					"devicePropertyCodes": [
						"Deviceid",
						"Examnumber",
						"Recordingnumber",
						"Examtime",
						"Examdate"
					],
					"deviceCriteria": [
						{
							"key": "Deviceid",
							"operator": "Equal",
							"value": deviceId,
						},
						{
							"key": "Surface",
							"operator": "IsSet",
						},
						{
							"key": "Lci",
							"operator": "IsSet",
						},
					],
					"ownerFilter": {
						"users": [],
						"practices": !practiceId ? [] : [practiceId],
						"suppliers": []
					}
				},
				{
					headers: {
						'x-tenant-domain': isProd ? X_TENENT_DOMAIN_PRD : X_TENENT_DOMAIN_DEV,
						'x-api-version': 3,
						'x-app-type': 'Device',
						'authorization': token,
					}
				});
		}
		catch (e) {
			if (e.response.status === 404) return { success: true, examList: [] };
			if (e.response.status === 401 || e.response.status === 412) {
				return { success: false, examList: [], errorType: this.error.AUTH_ERROR }
			}
			else {
				return { success: false, examList: [], errorType: this.error.UNKNOWN_API_ERROR_MSG }
			}
		}

		// create a list to be displayed to user showing the examnumber
		let examList = response.data.content.map((element) => {
			return {
				value: element.data.Examnumber.value + element.data.Examdate.value + element.data.Examtime.value, 
				examNumber: element.data.Examnumber.value,
				examDate:element.data.Examdate.value, 
				examTime:element.data.Examtime.value, 
				key:element.deviceDataId
			};
		});

		return { success: true, examList: examList };
	}

	static async getImageUrl(isProd, token, deviceDataId, imagePropertyCode) {

		let imageType;
		if (imagePropertyCode === 'surface') imageType = 'Surface';
		else if (imagePropertyCode === 'lci') imageType = 'Lci'

		let url = new URL('https://api.galencloud.com/data/devicedata-media/' +
			(isProd ? DEVICE_DATA_MODEL_PRD : DEVICE_DATA_MODEL_DEV) +
			'/' + deviceDataId + '/' + imageType);

		try {
			let response = await axios.get(url, {
				headers: {
					'x-tenant-domain': isProd ? X_TENENT_DOMAIN_PRD : X_TENENT_DOMAIN_DEV,
					'x-api-version': 3,
					'x-app-type': 'Device',
					'authorization': token,
				},
				responseType: 'blob',
			});

			// if invalid response, print error and set token to null
			if (response.status !== 200) return { success: false, errorType: this.error.UNKNOWN_API_ERROR_MSG };

			return { success: true, url: response.data }

		} catch (e) {
			// if an image is not found at expected location, return null
			if (e.response.status === 404) return { success: false, url: null, errorType: this.error.NOT_FOUND_ERROR };
			// for any other kind of failure, return error
			else return { success: false, url: null, errorType: this.error.UNKNOWN_API_ERROR_MSG };
		}
	}

	static async postInterpretationRequest(isProd, token, deviceId, examNumber, currentRecording, examDate, examTime, recording, ownerId) {
		let response;
		const ruuid = recording.deviceDataId;
		let d1 = new Date();
		const d2 = d1.toISOString();
		try {
			response = await axios.post('https://api.galencloud.com/data/devicedata',
			{
				"deviceDataModelId": "fd912401-2c8f-4a52-8698-45c9565c1025",
				"devicePropertySetId": "13bdfc23-9b34-44a7-aa1d-54ccfef6bbe9",
				"ownerId": ownerId,
				"data": {
					"Deviceid": deviceId,
					"Examnumber": examNumber,
					"Recordingnumber": currentRecording,
					"Recordinginstanceuuid": ruuid,
					"Examdate": examDate,
					"Examtime": examTime,
					"Uploadtime": d2
				}
			},
			{
				headers: {
					'x-tenant-domain': isProd ? X_TENENT_DOMAIN_PRD : X_TENENT_DOMAIN_DEV,
					'x-api-version': 3,
					'x-app-type': 'Device',
					'authorization': token,
				}
			});
		} catch (e) {
			return { success: false, errorType: this.error.UNKNOWN_API_ERROR_MSG, uuid: null };
		}
		return { success: true, uuid: response.data };
	}

	static async getRecordings(isProd, token, deviceId, examNumber, examDate, examTime, practiceId) {

		let response;
		try {
			let pageSize = "pageNumber=0&pageSize=1000"
			let sort = "sortBy=data.value.Examdate&sortOrder=DESC"
			let url = `${BASE_URL}/data/devicedata-advanced?${sort}&${pageSize}`
			response = await axios.post(url,
				{
					"deviceDataModelId": isProd ? DEVICE_DATA_MODEL_PRD : DEVICE_DATA_MODEL_DEV,

					"devicePropertyCodes": [
						"Deviceid",
						"Examnumber",
						"Recordingnumber",
						"Examtime",
						"Examdate",
						"Version",
						"Lci",
						"Surface"
					],
					"deviceCriteria": [
						{
							"key": "Deviceid",
							"operator": "Equal",
							"value": deviceId
						},
						{
							"key": "Examnumber",
							"operator": "Equal",
							"value": parseInt(examNumber)
						},
						{
							"key": "Examtime",
							"operator": "Equal",
							"value": examTime
						},
						{
							"key": "Examdate",
							"operator": "Equal",
							"value": examDate
						},
						{
							"key": "Surface",
							"operator": "IsSet",
						},
						{
							"key": "Lci",
							"operator": "IsSet",
						},
					],
					"ownerFilter": {
						"users": [],
						"practices": !practiceId ? [] : [practiceId],
						"suppliers": []
					}
				}
				,
				{
					headers: {
						'x-tenant-domain': isProd ? X_TENENT_DOMAIN_PRD : X_TENENT_DOMAIN_DEV,
						'x-api-version': 3,
						'x-app-type': 'Device',
						'authorization': token,
					}
				});
		} catch (e) {
			// if an exam is not found, return an empty list (not considering this an error)
			if (e.response.status === 404) return { success: true, recordingList: [] };
			// handle auth errors
			if (e.response.status === 401 || e.response.status === 412) {
				return { success: false, examList: [], errorType: this.error.AUTH_ERROR }
			}
			// for any other kind of failure, return error
			else return { success: false, recordingList: [], errorType: this.error.NOT_FOUND_ERROR };
		}
		// if we get an unexpected response code, report an error
		if (response.status !== 200) return { success: false, recordingList: [], errorType: this.error.UNKNOWN_API_ERROR_MSG };

		let recordingList = response.data.content.map((element) => {
			return {
				deviceDataId: element.deviceDataId,
				deviceId: element.data.hasOwnProperty('Deviceid') ? element.data.Deviceid.value : null,
				examNumber: element.data.hasOwnProperty('Examnumber') ? element.data.Examnumber.value : null,
				recordingNumber: element.data.hasOwnProperty('Recordingnumber') ? element.data.Recordingnumber.value : null,
				examTime: element.data.hasOwnProperty('Examtime') ? element.data.Examtime.value : null,
				examDate: element.data.hasOwnProperty('Examdate') ? element.data.Examdate.value : null,
				version: element.data.hasOwnProperty('Version') ? element.data.Version.value : null,
				lci: element.data.hasOwnProperty('Lci') ? element.data.Lci.value : null,
				surface: element.data.hasOwnProperty('Surface') ? element.data.Surface.value : null,
			};
		});

		return { success: true, recordingList: recordingList }
	}

	static async timeout(delay) {
		return new Promise(res => setTimeout(res, delay));
	}

	static async checkIfInterpretationRequestExists(isProd, token, uuid) {
		let response;
		try {
			response = await axios.post('https://api.galencloud.com/data/devicedata-advanced?pageNumber=0&pageSize=1000',
				{
					"deviceDataModelId": "fd912401-2c8f-4a52-8698-45c9565c1025",
					"devicePropertyCodes": [
						"Deviceid",
						"Examnumber",
						"Recordingnumber",
						"Examtime",
						"Examdate",
						"Version",
						"Recordinginstanceuuid",
						"Processingstatus",
						"Lci",
						"Surface"
					],
					"deviceCriteria": [

						{
							"key": "Recordinginstanceuuid",
							"operator": "Equal",
							"value": uuid
						},
						{
							"key": "Processingstatus",
							"operator": "Equal",
							"value": "success"
						},
					]
				}
				,
				{
					headers: {
						'x-tenant-domain': isProd ? X_TENENT_DOMAIN_PRD : X_TENENT_DOMAIN_DEV,
						'x-api-version': 3,
						'x-app-type': 'Device',
						'authorization': token,
					}
				});
		} catch (e) {
			// if an exam is not found, return an empty list (not considering this an error)
			if (e.response.status === 404) return { success: false, recordingList: [] };
			// handle auth errors
			if (e.response.status === 401 || e.response.status === 412) {
				return { success: false, examList: [], errorType: this.error.AUTH_ERROR }
			}
			// for any other kind of failure, return error
			else return { success: false, recordingList: [], errorType: this.error.NOT_FOUND_ERROR };
		}
		let interpretationRequestList = response.data.content.map((element) => {
			return {
				deviceDataId: element.deviceDataId,
			};
		});

		return { success: true, interpretationRequestList: interpretationRequestList }
	}

	static async getInterpretationResult(isProd, token, deviceId, uuid) {
		// initial poll
		
		let url = "https://api.galencloud.com/data/devicedata/" + "fd912401-2c8f-4a52-8698-45c9565c1025/" + uuid;
		try{
			let res = await axios.get(url, {
				headers: {
					'x-tenant-domain': isProd ? X_TENENT_DOMAIN_PRD : X_TENENT_DOMAIN_DEV,
					'x-api-version': 3,
					'x-app-type': 'Device',
					'authorization': token,
				},
			});
			if (res.data.data.Processingstatus.value != null){
				return { success: true, data: res.data };
			} 
			await this.timeout(10000);
		}catch (e){

		}
		// timer cnt variable
		let cnt = 0;
		while (cnt <= 100) {
			try {
				let res = await axios.get(url, {
					headers: {
						'x-tenant-domain': isProd ? X_TENENT_DOMAIN_PRD : X_TENENT_DOMAIN_DEV,
						'x-api-version': 3,
						'x-app-type': 'Device',
						'authorization': token,
					},
				});
				if (res.data.data.Processingstatus.value != null) return { success: true, data: res.data }
				await this.timeout(3000);
			} catch (e) {
				// increase the cnt, marking interpretation not ready yet.
				cnt++;
				await this.timeout(3000);
			}
		}
	}
}

export { galenApi }
